import { useMemo } from "react";

import Link from "next/link";

import {
  ProseMirror,
  ProseMirrorDoc,
  reactKeys,
} from "@handlewithcare/react-prosemirror";
import { Node } from "prosemirror-model";
import { EditorState } from "prosemirror-state";

import { schema } from "@/ai/components/Editor/schemas";
import {
  LessonSparkAttachment,
  PMJSONNode,
} from "@/bundles/types/LessonSparkAttachment";

import { titleCss, sectionCss } from "./AttachmentItem.styles";

interface AttachmentItemProps {
  selectedResource: LessonSparkAttachment;
}

const AttachmentItem = ({ selectedResource }: AttachmentItemProps) => {
  const useEditorStateFromJSON = (json?: PMJSONNode) => {
    return useMemo(() => {
      if (!json) return undefined;

      const doc = Node.fromJSON(schema, json);
      return EditorState.create({
        schema,
        doc,
        plugins: [reactKeys()],
      });
    }, [json, schema]);
  };

  const titleState = useEditorStateFromJSON(selectedResource?.data?.raw_title);
  const bodyState = useEditorStateFromJSON(selectedResource?.data?.raw_body);

  if (!selectedResource || (!titleState && !bodyState)) return null;

  return (
    <div css={sectionCss}>
      {titleState && (
        <div css={titleCss}>
          <ProseMirror editable={() => false} state={titleState}>
            <ProseMirrorDoc />
          </ProseMirror>
        </div>
      )}

      <Link
        target="_blank"
        rel="noopener nofollower noreferrer"
        href={`/lesson-sparks/${selectedResource.id}`}
      >
        Open full page view
      </Link>

      {bodyState && (
        <ProseMirror editable={() => false} state={bodyState}>
          <ProseMirrorDoc />
        </ProseMirror>
      )}
    </div>
  );
};

export default AttachmentItem;
